import { useState, useCallback } from 'react';

// Context para toast global (versão simplificada)
let globalToastQueue = [];
let globalSetToasts = null;

export const useToast = () => {
  const [toasts, setToasts] = useState([]);
  
  // Registra o setter global
  globalSetToasts = setToasts;

  const toast = useCallback(({ title, description, variant = 'default', duration = 4000 }) => {
    const id = Math.random().toString(36).substring(2, 9);
    const newToast = {
      id,
      title,
      description,
      variant,
      duration,
      timestamp: Date.now()
    };

    setToasts(prev => [...prev, newToast]);

    // Auto-dismiss toast after duration
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, duration);

    return id;
  }, []);

  const dismiss = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const dismissAll = useCallback(() => {
    setToasts([]);
  }, []);

  return {
    toast,
    dismiss,
    dismissAll,
    toasts
  };
};

// Standalone toast function for simple usage - agora funciona corretamente
export const toast = ({ title, description, variant = 'default', duration = 4000 }) => {
  const id = Math.random().toString(36).substring(2, 9);
  const newToast = {
    id,
    title,
    description,
    variant,
    duration,
    timestamp: Date.now()
  };

  // Se temos um setter global registrado, usa ele
  if (globalSetToasts) {
    globalSetToasts(prev => [...prev, newToast]);
    
    // Auto-dismiss
    setTimeout(() => {
      if (globalSetToasts) {
        globalSetToasts(prev => prev.filter(t => t.id !== id));
      }
    }, duration);
  } else {
    // Fallback para console
    console.log(`Toast: ${title}`, description, variant);
    
    // Tentar notificação do navegador
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification(title, {
        body: description,
        icon: '/vite.svg'
      });
    }
  }
  
  return id;
}; 